import { ANIMATION_CONFIG } from "./constants";

export const getEnterTransition = (delay = 0) => ({
  type: "spring",
  stiffness: 300,
  damping: 20,
  duration: ANIMATION_CONFIG.ENTER_DURATION,
  delay: delay,
});

export const getFadeInTransition = (delay = 0) => ({
  type: "tween",
  ease: "easeOut",
  duration: ANIMATION_CONFIG.ENTER_DURATION,
  delay: delay,
});

export const getExitTransition = () => ({
  type: "tween",
  ease: "easeOut",
  duration: ANIMATION_CONFIG.EXIT_DURATION,
});

/**
 * NEW: Calculates the `times` array for the *new* short entering animation.
 * Keyframes: [START (idx 0), LAND (idx 1), HOLD (idx 2), SMALL (idx 3)]
 * This corresponds to 4 keyframes.
 */
export const calculateEnterTimes = (
  totalDuration: number,
  pulseStartTime: number
) => {
  const { ENTER_DURATION } = ANIMATION_CONFIG;

  const t = (time: number) => {
    const calculatedTime = time / totalDuration;
    if (calculatedTime < 0) return 0;
    if (calculatedTime > 1) return 1;
    return calculatedTime;
  };

  const enterEnd = t(ENTER_DURATION);
  const pulseStart = t(pulseStartTime);

  return [
    0, // Start (index 0)
    enterEnd, // Land (index 1)
    pulseStart, // Hold (index 2)
    1.0, // End at SMALL (index 3)
  ];
};

export const calculatePulseLoopTimes = () => {
  const {
    PULSE_DURATION_HOLD,
    PULSE_DURATION_IN,
    PULSE_DURATION_HOLD_BIG,
    PULSE_DURATION_OUT,
    PULSE_CYCLE_DURATION,
  } = ANIMATION_CONFIG;

  const totalDuration = PULSE_CYCLE_DURATION;
  const t = (time: number) => {
    const calculatedTime = time / totalDuration;
    if (calculatedTime < 0) return 0;
    if (calculatedTime > 1) return 1;
    return calculatedTime;
  };

  return [
    0, // Start at SMALL (index 3)
    t(PULSE_DURATION_HOLD), // Time to SMALL-HOLD (index 4)
    t(PULSE_DURATION_HOLD + PULSE_DURATION_IN), // Time to BIG (index 5)
    t(PULSE_DURATION_HOLD + PULSE_DURATION_IN + PULSE_DURATION_HOLD_BIG), // Time to BIG-HOLD (index 6)
    1.0, // Time to return to SMALL (index 7)
  ];
};